import Vue from "vue";
import Router from "vue-router";
import Home from "@/modules/home/HomeModule.vue";
import Login from "@/modules/auth/AuthModule.vue";
import ComingSoon from "@/modules/auth/ComingSoonModule.vue";
import Users from "@/modules/users/Users.vue";
import AddUsers from "@/modules/users/AddUser.vue";
import store from "@/store/index";
import { ToastProgrammatic as Toast } from "buefy";

Vue.use(Router);

const ifAuthenticated = async (to, from, next) => {
  if (from.name === "login") {
    next();
    return;
  } else if (to.name === "login") {
    await store.dispatch("SET_SCREEN_LOADING", true);
    // dispatch logout code
    await store.dispatch("SET_SCREEN_LOADING", false);
  } else if (store.getters["loginStore/getIsAuthenticated"]) {
    await store.dispatch("SET_SCREEN_LOADING", true);
    if (!from.name && to.name) {
      await store.dispatch(
        "loginStore/handleFetchMyDetailsResponse",
        store.getters["loginStore/getResponseObject"]
      );
      if (store.getters["globalStore/isInternal"]) {
        await store.dispatch("SET_SCREEN_LOADING", false);
        next();
        return;
      }
      // await store.dispatch("globalStore/fetchMyLearners");
    }
    await store.dispatch("SET_SCREEN_LOADING", false);
    next();
    return;
  }

  Toast.open({
    message: "Please Login to access the dashboard",
    queue: false,
    type: "is-danger",
    duration: 5000
  });
  next("/login");
};

export default new Router({
  //base: process.env.BASE_URL,
  mode: "history",
  linkActiveClass: "router-link-active is-active",
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/tutor-company",
      name: "coming-soon",
      component: ComingSoon,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/dashboard",
      name: "home",
      component: Home,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/addUsers",
      name: "addUsers",
      component: AddUsers,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/internal",
      name: "internal",
      component: () =>
        import(
          /* webpackChunkName: "chat" */ "@/modules/internalUser/InternalUser.vue"
        ),
      beforeEnter: ifAuthenticated
    },
    {
      path: "/internal-tools",
      name: "internal-tools",
      component: () =>
        import(
          /* webpackChunkName: "internal-tools" */ "@/modules/admin-management/AdminManagementModule.vue"
        ),
      beforeEnter: ifAuthenticated
    },
    {
      path: "/404",
      name: "pageNotFound",
      component: () => import("@/views/PageNotFound.vue")
    },
    { path: "*", redirect: "/404" }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
